import React from "react"
import PostAnime from "../Component/postAnime/postAnime"
const postAnime =()=>{
 
    return(
     <PostAnime />

    )
}
export default postAnime


// WEBPACK FOOTER //
// ./src/Container/PostAnime.jsx